module.exports = __webpack_public_path__ + "img/class_physical_L1.01edc6e1.jpg";